import React from "react";
import {apiReloginMerchant} from "../../../../../../../api/_auth";

import Ripple from "../../../../../../dumb/Ripple";
import LogoutBtn from '../../../../helpers/LogoutBtn';

export default (account) => {
  const accountsList = account.accountsList || [];

  const accLogoutBtn = <LogoutBtn />;
  const divider = {divider: true};

  const dropdownItems = [];

  accountsList.forEach((acc, i) => {
    dropdownItems.push(
      <Ripple
        key={i}
        onClick={() => apiReloginMerchant({id: acc.id})}
      >
        {acc.login}
      </Ripple>
    )
  })

  return (
    [
      ...dropdownItems,
      divider,
      accLogoutBtn
    ]
  );
}
